/* eslint-disable max-len */
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import AnimatedList from '../../../../../../../components/Animation/AnimatedList'
import AnimatedModel from '../../../../../../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../../../../../../components/ConfirmationPrompt'
import { convertToPatientTimeZoneDateFormat } from '../../../../../../../CommonMethods/ConvertDatetoPatientTimezone'

const TableBody = ({
    vitalTabName,
    tableData,
    indexNum,
}) => {
    const [detailsModal,setDetailsModal] = useState(false);
    const [deviceDetails,setDeviceDetails] = useState()
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const date=convertToPatientTimeZoneDateFormat(tableData?.measurement_date_time,dateformat,tableData?.timezone)

    return(
        <>
            <AnimatedList
                id={tableData.user_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                child={
                    <> 
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624]">
                            {date}
                        </td>
                        {
                            vitalTabName==='All'&& <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624]">
                                {tableData?.reading_type==='spo2'?'SPO2':(tableData?.reading_type)?.split('_')?.map((word)=>word.charAt(0).toUpperCase()+word.slice(1)).join(' ')}
                            </td>
                        }
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624]">
                            {(tableData?.alert_type === undefined || tableData?.alert_type === "" ) ? "-" : tableData?.alert_type}
                        </td>
                       
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all" style={{lineBreak:'anywhere'}}>
                            {(tableData?.reading === undefined || tableData?.reading === "") ? "-" : tableData?.reading}
                        </td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal break-all' style={{lineBreak:'anywhere'}}>
                            {/* Splitting the reading_details by "/" */}
                            <span className={`${tableData?.reading_details?.includes('/') ? "flex" : ""}`}>
                                {tableData?.reading_details?.split('/').map((detail, index, array) => (
                                    <span key={index}>
                                        <span 
                                            className={`${detail === 'Too Low' ? "bg-[#F9E8E9] text-[#D3454D]" : 
                                                detail === 'Too High' ? 'bg-[#EEB9BC] text-[#C81720]' : 
                                                    detail === 'Nominal' ? 'bg-[#9BD6AD] text-[#1A883C]' : 
                                                        (detail === 'Missed Reading' || detail === 'Data Error') ? 'bg-[#E7EAF4] text-[#000000]' : "" } 
                                                        rounded-[28px] px-2 py-1`}
                                        >
                                            {detail}
                                        </span>
                                        {index < array.length - 1 && <span className="mx-1">/</span>}
                                    </span>
                                ))}
                            </span>
                        </td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all' style={{lineBreak:'anywhere'}}>
                            {(tableData?.threshold === undefined || tableData?.threshold === "") ? "-" : tableData?.threshold?.includes('/')?tableData?.threshold?.split('/')[0]+" / "+tableData?.threshold?.split('/')[1]:tableData?.threshold }
                        </td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all cursor-pointer'
                            onClick={()=>{
                                setDetailsModal(true); 
                                setDeviceDetails(tableData);
                            }}
                        >
                            {(tableData?.device_id === undefined || tableData?.device_id === "") ? "-" : tableData?.device_id}
                        </td>
                     
                    </>
                    
                }/>
            {detailsModal &&
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleClose={() => setDetailsModal(false)}
                        tittle= {'Details:'}
                        showingInfo={true}
                        deviceDetails={deviceDetails}
                    />
                }
            />
            }
        </>
    )
}

export default TableBody